import { lazy, Suspense } from 'react';

import {
  ComponentHeightWrapper,
  ComponentInnerWrapper,
} from '../shared/component-height/component-dimensions.style';
import { computePaddingTop } from '../shared/component-height/component-dimension.utils';
import {
  PlayableComponentButton,
  PlayableComponentButtonText,
} from '../shared/playable-component.style';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { ViewProps } from './image-sphere.constants';
import { ImageContainer } from '../image/image.style';
import { ImageViewFill } from '../image/image-view';
import ImageSphereTag from './image-sphere-tag';
import { getComponentSelectorId } from '../shared/logic/get-component-selector-id';
import ActivitySheet from '../shared/sheet/activity-sheet';
import ImageSphereViewerLoading from './image-sphere-viewer-loading';

const ImageSphereViewer = lazy(() => import('./image-sphere-viewer'));

const ImageSphereView = (props: ViewProps) => {
  const { isVisible, openModal, closeModal } = useSimpleModalState();

  const { properties } = props;

  return (
    <ComponentHeightWrapper
      style={{
        paddingTop: `${computePaddingTop(properties.dimensionData)}%`,
      }}
    >
      <ComponentInnerWrapper id={getComponentSelectorId(props.id)}>
        {isVisible && (
          <ActivitySheet
            isVisible
            title="Viewing 360 image"
            onClose={closeModal}
          >
            <Suspense fallback={<ImageSphereViewerLoading />}>
              <ImageSphereViewer {...props} />
            </Suspense>
          </ActivitySheet>
        )}
        <ImageContainer>
          <ImageViewFill
            altText={properties.altText}
            imageUrls={properties.printImageUrls || []}
          />
        </ImageContainer>
        <PlayableComponentButton
          type="button"
          aria-label="Click to view the 360 image"
          onClick={openModal}
          data-selector="btn-start"
        >
          <PlayableComponentButtonText>Start</PlayableComponentButtonText>
        </PlayableComponentButton>
        <ImageSphereTag />
      </ComponentInnerWrapper>
    </ComponentHeightWrapper>
  );
};

export default ImageSphereView;
